export default function UserDashboard(){
    return <div>User</div>
}